import { base } from "../../constants/base";
import { countRating } from "../../constants/base";

const PopularProfessionalCard = ({ professional }) => {
  return (
    <div className="popular-professional-card">
      <div className="popular-card-image">
        {professional.images.map((image) =>
          (image.type === "profile" || image.type === "logo") ? (
            image.path ? (
              <img src={base.imageUrl + image?.path} alt="" />
            ) : (
              <img src="/noimage.png" alt="" />
            )
          ) : ("")
        )}
        <span className="rating-star">
          <i className="fa-solid fa-star"></i>
          {/* {professional?.requests && countRating(professional?.requests)} */}
          {/* {professional?.requests?.length > 0 ? countRating(professional?.requests) : 0} */}
          {professional?.feedback_average != null ? parseFloat(professional.feedback_average).toFixed(1) : '0.0'}


        </span>
      </div>

      <div className="popular-card-text">
        <h1>{professional?.name}</h1>
        <h3>{professional?.role?.name}</h3>
        <p>{professional?.total_assigned_services} Services</p>
      </div>
    </div>
  );
};

export default PopularProfessionalCard;
